<template>
  <div>
    <Manpowermenubar_govem />

    <v-container fluid class="pa-4 pa-md-6 app-bg">
      <!-- การจัดการกรอบอัตราโดยส่วนกลาง (เพิ่มกรอบ / ตัดโอนตำแหน่ง / ย้าย) + ตรวจรายชื่อซ้ำ/ค้าง -->
      <govem-frame-actions ref="frame" @changed="onFilterChange" />
      <govem-data-quality admin @changed="onFilterChange" />
      <div class="d-flex justify-end mb-3">
        <v-btn small outlined color="blue-grey darken-1" @click="$refs.auditLog.open(2)">
          <v-icon small left>mdi-history</v-icon>Log สถานศึกษา / คำขอกู้คืน
        </v-btn>
      </div>
      <unit-audit-log ref="auditLog" admin @restored="onFilterChange" />
      <govem-budget-request ref="budgetRequest" />
      <!-- ===== Header Card ===== -->
      <v-card class="mb-5 elevation-2 rounded-xl header-card">
        <v-card-title class="d-flex align-center py-4 px-6 header-title-bar">
          <div>
            <h1 class="text-h5 text-md-h4 font-weight-bold white--text">
              <v-icon left color="white" large>mdi-account-group</v-icon>
              บริหารจัดการอัตรากำลังพนักงานราชการ
            </h1>
            <div class="white--text text--lighten-2 mt-1 ml-10 text-body-2">
              สำนักงานคณะกรรมการการอาชีวศึกษา
            </div>
          </div>
          <v-spacer></v-spacer>
          <div class="text-right d-flex" style="gap: 8px;">
            <v-btn
              color="white"
              outlined
              @click="exportSummaryToCSV"
              :loading="isExporting"
            >
              <v-icon left>mdi-microsoft-excel</v-icon> ส่งออกสรุป
            </v-btn>
            <v-btn color="white" outlined @click="exportToCSV">
              <v-icon left>mdi-download</v-icon> ส่งออกรายชื่อ
            </v-btn>
            <v-btn color="white" outlined @click="$refs.budgetRequest.open()">
              <v-icon left>mdi-cash-multiple</v-icon> คำขอจัดสรรงบ งวด 1 (ต.ค.–ธ.ค.)
            </v-btn>
          </div>
        </v-card-title>

        <!-- ===== Filter Section ===== -->
        <v-card-text class="px-6 py-5 filter-section">
          <div class="d-flex align-center mb-3">
            <v-icon color="primary" class="mr-2">mdi-filter-variant</v-icon>
            <span class="text-subtitle-1 font-weight-bold primary--text"
              >ตัวกรองข้อมูล</span
            >
            <v-spacer></v-spacer>
            <v-btn
              text
              small
              color="grey darken-1"
              @click="resetFilters"
              class="text-capitalize"
            >
              <v-icon small left>mdi-refresh</v-icon>ล้างตัวกรอง
            </v-btn>
          </div>

          <v-row dense class="mb-2">
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="search"
                label="ค้นหาเลขที่ตำแหน่ง / ชื่อ"
                placeholder="กรอกเลขที่ตำแหน่งหรือชื่อ"
                prepend-inner-icon="mdi-magnify"
                @keyup.enter="idPosition_search"
                clearable
                outlined
                dense
                background-color="white"
                hide-details
                class="filter-input"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-autocomplete
                v-model="college_search"
                :items="colleges"
                item-text="organization_name"
                item-value="user_code"
                label="วิทยาลัย"
                prepend-inner-icon="mdi-home-city"
                clearable
                outlined
                dense
                background-color="white"
                hide-details
                class="filter-input"
                @change="onFilterChange"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-autocomplete
                v-model="province_search"
                :items="provinces"
                item-text="province_name"
                item-value="province_ID"
                label="จังหวัด"
                prepend-inner-icon="mdi-map-marker"
                clearable
                outlined
                dense
                background-color="white"
                hide-details
                class="filter-input"
                @change="onFilterChange"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-select
                v-model="vacancy_filter"
                :items="vacancyFilterOptions"
                item-text="text"
                item-value="value"
                label="สถานะอัตรา"
                prepend-inner-icon="mdi-account-check"
                clearable
                outlined
                dense
                background-color="white"
                hide-details
                class="filter-input"
                @change="onFilterChange"
              ></v-select>
            </v-col>
          </v-row>

          <!-- Active Filters -->
          <v-slide-y-transition>
            <div
              v-if="hasActiveFilters"
              class="mt-3 d-flex align-center flex-wrap"
            >
              <v-icon small color="warning darken-2" class="mr-1"
                >mdi-filter-check</v-icon
              >
              <span
                class="text-caption warning--text text--darken-2 font-weight-medium mr-2"
                >ตัวกรองที่ใช้งาน:</span
              >
              <v-chip
                v-if="college_search"
                x-small
                close
                class="mr-1 mb-1"
                color="warning lighten-4"
                text-color="warning darken-3"
                @click:close="
                  college_search = '';
                  onFilterChange();
                "
              >
                วิทยาลัย: {{ getCollegeName(college_search) }}
              </v-chip>
              <v-chip
                v-if="province_search"
                x-small
                close
                class="mr-1 mb-1"
                color="warning lighten-4"
                text-color="warning darken-3"
                @click:close="
                  province_search = '';
                  onFilterChange();
                "
              >
                จังหวัด: {{ getProvinceName(province_search) }}
              </v-chip>
              <v-chip
                v-if="vacancy_filter"
                x-small
                close
                class="mr-1 mb-1"
                color="warning lighten-4"
                text-color="warning darken-3"
                @click:close="
                  vacancy_filter = '';
                  onFilterChange();
                "
              >
                สถานะ: {{ getVacancyFilterLabel(vacancy_filter) }}
              </v-chip>
              <v-chip
                x-small
                outlined
                color="grey"
                class="ml-1 mb-1"
                @click="resetFilters"
                >ล้างทั้งหมด</v-chip
              >
            </div>
          </v-slide-y-transition>
        </v-card-text>
      </v-card>

      <!-- ===== Summary Cards Row 1 ===== -->
      <v-row class="mb-5">
        <v-col cols="12" sm="6" lg="3">
          <v-card
            class="rounded-xl elevation-2 summary-card summary-card--total"
          >
            <v-card-text class="pa-5">
              <div class="d-flex align-center justify-space-between mb-3">
                <div class="summary-icon-wrap summary-icon--blue">
                  <v-icon color="white" size="28">mdi-account-multiple</v-icon>
                </div>
                <v-chip x-small color="primary" dark>อัตรากำลังทั้งหมด</v-chip>
              </div>
              <div class="text-h4 font-weight-black mb-1">
                {{ summaryStats.total_employees }}
              </div>
              <div class="text-body-2 grey--text text--darken-1">
                รวมอัตรากำลัง
              </div>
              <v-divider class="my-3"></v-divider>
              <div class="d-flex text-caption">
                <span class="success--text font-weight-bold mr-3">
                  <v-icon x-small color="success">mdi-account-check</v-icon>
                  {{ summaryStats.filled_count }} ครองตำแหน่ง
                </span>
                <span class="error--text font-weight-bold">
                  <v-icon x-small color="error">mdi-account-off</v-icon>
                  {{ summaryStats.vacancy_count }} อัตราว่าง
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" lg="3">
          <v-card
            class="rounded-xl elevation-2 summary-card summary-card--vacancy"
          >
            <v-card-text class="pa-5">
              <div class="d-flex align-center justify-space-between mb-3">
                <div class="summary-icon-wrap summary-icon--red">
                  <v-icon color="white" size="28">mdi-account-alert</v-icon>
                </div>
                <v-progress-circular
                  :value="vacancyPercentage"
                  :color="vacancyPercentage > 15 ? 'error' : 'warning'"
                  :size="42"
                  :width="5"
                  :rotate="-90"
                >
                  <span class="text-caption font-weight-bold"
                    >{{ vacancyPercentage }}%</span
                  >
                </v-progress-circular>
              </div>
              <div class="text-h4 font-weight-black mb-1 error--text">
                {{ summaryStats.vacancy_count }}
              </div>
              <div class="text-body-2 grey--text text--darken-1">อัตราว่าง</div>
              <v-divider class="my-3"></v-divider>
              <div class="text-caption">
                <span class="font-weight-bold warning--text">
                  <v-icon x-small color="warning">mdi-alert</v-icon>
                  ว่างใน {{ summaryStats.vacancy_college_count }} สถานศึกษา
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" lg="3">
          <v-card
            class="rounded-xl elevation-2 summary-card summary-card--salary"
          >
            <v-card-text class="pa-5">
              <div class="d-flex align-center justify-space-between mb-3">
                <div class="summary-icon-wrap summary-icon--green">
                  <v-icon color="white" size="28">mdi-cash-multiple</v-icon>
                </div>
                <span class="text-caption grey--text">เงินเดือนรวม</span>
              </div>
              <div class="text-h5 font-weight-black mb-1">
                {{ formatCurrencyShort(summaryStats.total_salary) }}
              </div>
              <div class="text-body-2 grey--text text--darken-1">
                {{ summaryStats.total_salary | currency }}
              </div>
              <v-divider class="my-3"></v-divider>
              <div class="d-flex text-caption justify-space-between">
                <span>
                  <v-icon x-small color="info">mdi-cash</v-icon>
                  เฉลี่ย {{ summaryStats.avg_salary | currency }}
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" lg="3">
          <v-card
            class="rounded-xl elevation-2 summary-card summary-card--gender"
          >
            <v-card-text class="pa-5">
              <div class="d-flex align-center justify-space-between mb-3">
                <div class="summary-icon-wrap summary-icon--purple">
                  <v-icon color="white" size="28"
                    >mdi-gender-male-female</v-icon
                  >
                </div>
                <span class="text-caption grey--text">ข้อมูลบุคลากร</span>
              </div>
              <div class="text-h5 font-weight-black mb-1">
                {{ summaryStats.male_count }} / {{ summaryStats.female_count }}
              </div>
              <div class="text-body-2 grey--text text--darken-1">
                ชาย / หญิง
              </div>
              <v-divider class="my-3"></v-divider>
              <div class="d-flex text-caption justify-space-between">
                <span class="success--text font-weight-bold">
                  <v-icon x-small color="success"
                    >mdi-card-account-details</v-icon
                  >
                  มีบัตร {{ summaryStats.with_idcard_count }}
                </span>
                <span class="warning--text font-weight-bold">
                  <v-icon x-small color="warning">mdi-card-off</v-icon>
                  ไม่มี {{ summaryStats.no_idcard_count }}
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- ===== Summary Cards Row 2: Salary Range ===== -->
      <v-row class="mb-5">
        <v-col cols="12" sm="4">
          <v-card outlined class="rounded-lg pa-4 text-center">
            <v-icon color="error" size="32" class="mb-2"
              >mdi-arrow-bottom-left</v-icon
            >
            <div class="text-h5 font-weight-bold error--text">
              {{ summaryStats.min_salary | currency }}
            </div>
            <div class="text-caption grey--text">เงินเดือนต่ำสุด</div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card outlined class="rounded-lg pa-4 text-center">
            <v-icon color="info" size="32" class="mb-2">mdi-minus</v-icon>
            <div class="text-h5 font-weight-bold info--text">
              {{ summaryStats.avg_salary | currency }}
            </div>
            <div class="text-caption grey--text">เงินเดือนเฉลี่ย</div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card outlined class="rounded-lg pa-4 text-center">
            <v-icon color="success" size="32" class="mb-2"
              >mdi-arrow-top-right</v-icon
            >
            <div class="text-h5 font-weight-bold success--text">
              {{ summaryStats.max_salary | currency }}
            </div>
            <div class="text-caption grey--text">เงินเดือนสูงสุด</div>
          </v-card>
        </v-col>
      </v-row>

      <!-- ===== Vacancy Alert Section ===== -->
      <v-card
        class="rounded-xl elevation-2 mb-5"
        v-if="vacancyCollegeSummary.length > 0"
      >
        <v-card-title class="py-3 px-5 vacancy-header">
          <v-icon left color="white" small>mdi-account-alert</v-icon>
          <span class="text-subtitle-1 font-weight-bold white--text">
            อัตราว่าง แยกตามสถานศึกษา ({{ summaryStats.vacancy_count }} อัตรา)
          </span>
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            x-small
            outlined
            @click="showAllVacancies = !showAllVacancies"
          >
            {{ showAllVacancies ? "แสดงน้อยลง" : "แสดงทั้งหมด" }}
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4 px-5 pb-4">
          <v-row dense>
            <v-col
              v-for="(vc, idx) in displayVacancyColleges"
              :key="idx"
              cols="12"
              sm="6"
              md="4"
              lg="3"
            >
              <v-card
                outlined
                class="rounded-lg pa-3 vacancy-college-card"
                @click="filterByCollege(vc.user_code)"
              >
                <div class="d-flex align-center">
                  <v-avatar
                    size="36"
                    :color="
                      vc.vacancy_count > 5
                        ? 'error lighten-4'
                        : 'warning lighten-4'
                    "
                    class="mr-3"
                  >
                    <span
                      class="font-weight-bold"
                      :class="
                        vc.vacancy_count > 5
                          ? 'red--text text--darken-2'
                          : 'orange--text text--darken-2'
                      "
                    >
                      {{ vc.vacancy_count }}
                    </span>
                  </v-avatar>
                  <div style="min-width:0;flex:1;">
                    <div
                      class="text-body-2 font-weight-bold text-truncate"
                      :title="vc.organization_name"
                    >
                      {{ vc.organization_name }}
                    </div>
                    <div class="text-caption grey--text">
                      รหัส {{ vc.user_code }} | ว่าง {{ vc.vacancy_count }} จาก
                      {{ vc.total_count }} อัตรา
                    </div>
                  </div>
                </div>
                <v-progress-linear
                  :value="
                    ((vc.total_count - vc.vacancy_count) / vc.total_count) * 100
                  "
                  :color="vc.vacancy_count > 5 ? 'error' : 'warning'"
                  height="4"
                  rounded
                  class="mt-2"
                >
                </v-progress-linear>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- ===== Tabs Section ===== -->
      <v-card class="rounded-xl elevation-2 overflow-hidden">
        <v-tabs
          v-model="activeTab"
          background-color="white"
          color="primary"
          grow
          show-arrows
          class="border-bottom"
        >
          <v-tab
            ><v-icon left small>mdi-chart-bar</v-icon
            ><span class="d-none d-sm-inline">สถิติภาพรวม</span
            ><span class="d-inline d-sm-none">สถิติ</span></v-tab
          >
          <v-tab
            ><v-icon left small>mdi-school</v-icon
            ><span class="d-none d-sm-inline">สรุปตามสถานศึกษา</span
            ><span class="d-inline d-sm-none">สถานศึกษา</span></v-tab
          >
          <v-tab
            ><v-icon left small>mdi-account-details</v-icon
            ><span class="d-none d-sm-inline">รายชื่อบุคลากร</span
            ><span class="d-inline d-sm-none">รายชื่อ</span></v-tab
          >
          <v-tab>
            <v-icon left small>mdi-account-alert</v-icon>
            <span class="d-none d-sm-inline">อัตราว่าง</span
            ><span class="d-inline d-sm-none">ว่าง</span>
            <v-badge
              v-if="summaryStats.vacancy_count > 0"
              :content="summaryStats.vacancy_count"
              color="error"
              class="ml-2"
            ></v-badge>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab">
          <!-- ===== TAB 1: สถิติภาพรวม ===== -->
          <v-tab-item>
            <v-container fluid class="pa-4">
              <v-row class="mb-4">
                <v-col cols="12" md="4">
                  <v-card outlined class="rounded-lg pa-4 h-100">
                    <h3 class="text-subtitle-1 font-weight-bold mb-2">
                      <v-icon small color="primary" class="mr-1"
                        >mdi-chart-pie</v-icon
                      >สัดส่วนเพศ
                    </h3>
                    <apexchart
                      v-if="genderChartSeries.length > 0"
                      type="donut"
                      :options="genderChartOptions"
                      :series="genderChartSeries"
                      height="280"
                    />
                    <div v-else class="text-center py-8">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </div>
                    <div class="text-center mt-2">
                      <v-chip color="info" text-color="white" small class="mr-2"
                        ><v-icon small left>mdi-human-male</v-icon>ชาย
                        {{ summaryStats.male_count }} คน</v-chip
                      >
                      <v-chip color="primary" text-color="white" small
                        ><v-icon small left>mdi-human-female</v-icon>หญิง
                        {{ summaryStats.female_count }} คน</v-chip
                      >
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card outlined class="rounded-lg pa-4 h-100">
                    <h3 class="text-subtitle-1 font-weight-bold mb-2">
                      <v-icon small color="warning" class="mr-1"
                        >mdi-chart-donut</v-icon
                      >สถานะอัตรากำลัง
                    </h3>
                    <apexchart
                      v-if="vacancyChartSeries.length > 0"
                      type="donut"
                      :options="vacancyChartOptions"
                      :series="vacancyChartSeries"
                      height="280"
                    />
                    <div v-else class="text-center py-8">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </div>
                    <div class="text-center mt-2">
                      <v-chip
                        color="success"
                        text-color="white"
                        small
                        class="mr-2"
                        >ครองตำแหน่ง {{ summaryStats.filled_count }}</v-chip
                      >
                      <v-chip color="error" text-color="white" small
                        >ว่าง {{ summaryStats.vacancy_count }}</v-chip
                      >
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card outlined class="rounded-lg pa-4 h-100">
                    <h3 class="text-subtitle-1 font-weight-bold mb-2">
                      <v-icon small color="info" class="mr-1"
                        >mdi-card-account-details</v-icon
                      >สถานะเลขบัตรประชาชน
                    </h3>
                    <apexchart
                      v-if="idcardChartSeries.length > 0"
                      type="donut"
                      :options="idcardChartOptions"
                      :series="idcardChartSeries"
                      height="280"
                    />
                    <div v-else class="text-center py-8">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </div>
                    <div class="text-center mt-2">
                      <v-chip color="info" text-color="white" small class="mr-2"
                        >มีบัตร {{ summaryStats.with_idcard_count }}</v-chip
                      >
                      <v-chip color="grey" text-color="white" small
                        >ไม่มี {{ summaryStats.no_idcard_count }}</v-chip
                      >
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <v-row class="mb-4">
                <v-col cols="12" md="6">
                  <v-card outlined class="rounded-lg pa-4">
                    <h3 class="text-subtitle-1 font-weight-bold mb-2">
                      <v-icon small color="warning" class="mr-1"
                        >mdi-chart-bar</v-icon
                      >สถิติเงินเดือนตามช่วง
                    </h3>
                    <apexchart
                      v-if="salaryRangeChartSeries.length > 0"
                      type="bar"
                      :options="salaryRangeChartOptions"
                      :series="salaryRangeChartSeries"
                      height="350"
                    />
                    <div v-else class="text-center py-8">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card outlined class="rounded-lg pa-4">
                    <h3 class="text-subtitle-1 font-weight-bold mb-2">
                      <v-icon small color="success" class="mr-1"
                        >mdi-chart-bar</v-icon
                      >จำนวนตามตำแหน่ง
                    </h3>
                    <apexchart
                      v-if="positionChartSeries.length > 0"
                      type="bar"
                      :options="positionChartOptions"
                      :series="positionChartSeries"
                      height="350"
                    />
                    <div v-else class="text-center py-8">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-card outlined class="rounded-lg pa-4">
                    <h3 class="text-subtitle-1 font-weight-bold mb-2">
                      <v-icon small color="primary" class="mr-1"
                        >mdi-school</v-icon
                      >สถิติการศึกษา
                    </h3>
                    <apexchart
                      v-if="educationChartSeries.length > 0"
                      type="bar"
                      :options="educationChartOptions"
                      :series="educationChartSeries"
                      height="350"
                      :key="educationChartKey"
                    />
                    <div v-else class="text-center py-8">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card outlined class="rounded-lg pa-4">
                    <h3 class="text-subtitle-1 font-weight-bold mb-2">
                      <v-icon small color="primary" class="mr-1"
                        >mdi-chart-pie</v-icon
                      >ประเภทตำแหน่ง
                    </h3>
                    <apexchart
                      v-if="positionTypeChartSeries.length > 0"
                      type="pie"
                      :options="positionTypeChartOptions"
                      :series="positionTypeChartSeries"
                      height="350"
                    />
                    <div v-else class="text-center py-8">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <!-- ===== TAB 2: สรุปตามสถานศึกษา ===== -->
          <v-tab-item>
            <v-container fluid class="pa-4">
              <v-card class="rounded-lg" flat>
                <v-card-title class="flex-wrap pb-2">
                  <v-icon left color="primary">mdi-school</v-icon>
                  สรุปตามสถานศึกษา (จำแนกประเภทตำแหน่ง)
                  <v-spacer></v-spacer>
                  <div class="d-flex align-center flex-wrap" style="gap:8px;">
                    <v-btn-toggle
                      v-model="collegeSummaryView"
                      dense
                      color="primary"
                      mandatory
                    >
                      <v-btn small value="compact"
                        ><v-icon small left>mdi-view-list</v-icon
                        ><span class="d-none d-sm-inline">สรุป</span></v-btn
                      >
                      <v-btn small value="full"
                        ><v-icon small left>mdi-table-large</v-icon
                        ><span class="d-none d-sm-inline">เต็ม</span></v-btn
                      >
                    </v-btn-toggle>
                    <v-text-field
                      v-model="search_college"
                      append-icon="mdi-magnify"
                      label="ค้นหาสถานศึกษา"
                      outlined
                      dense
                      rounded
                      hide-details
                      style="max-width:260px;"
                    ></v-text-field>
                    <v-btn
                      color="success"
                      small
                      @click="exportCollegeSummaryXLSX"
                      :loading="isExportingXLSX"
                    >
                      <v-icon small left>mdi-microsoft-excel</v-icon> ส่งออก
                      XLSX
                    </v-btn>
                    <v-btn
                      color="info"
                      small
                      outlined
                      @click="exportSummaryToCSV"
                    >
                      <v-icon small left>mdi-file-delimited</v-icon> CSV
                    </v-btn>
                  </div>
                </v-card-title>

                <v-card-text class="pt-0 pb-3 px-4">
                  <div class="d-flex flex-wrap align-center" style="gap:6px;">
                    <span class="text-caption grey--text mr-1"
                      >กลุ่มตำแหน่ง:</span
                    >
                    <v-chip
                      v-for="g in positionGroups"
                      :key="g.key"
                      x-small
                      label
                      :color="g.chipColor"
                      :text-color="g.chipTextColor"
                    >
                      <v-icon x-small left>{{ g.icon }}</v-icon
                      >{{ g.label }}
                    </v-chip>
                  </div>
                </v-card-text>

                <v-data-table
                  :headers="activeCollegeSummaryHeaders"
                  :items="collegeSummaryWithPositions"
                  :loading="loading"
                  class="elevation-0 college-position-table"
                  :items-per-page="20"
                  :footer-props="{
                    itemsPerPageOptions: [10, 15, 20, 50, -1],
                    itemsPerPageText: 'แสดง'
                  }"
                  :search="search_college"
                  fixed-header
                  height="560"
                >
                  <template v-slot:item.organization_name="{ item }">
                    <div
                      class="font-weight-bold text-body-2"
                      style="max-width:200px;"
                    >
                      {{ item.organization_name }}
                    </div>
                    <div class="text-caption grey--text">
                      รหัส {{ item.user_code }}
                    </div>
                  </template>

                  <template v-slot:item.filled_rate="{ item }">
                    <v-progress-linear
                      :value="item.filled_rate || 0"
                      :color="getPercentageColor(item.filled_rate || 0)"
                      height="18"
                      rounded
                    >
                      <template v-slot:default="{ value }">
                        <strong class="white--text text-caption"
                          >{{ Math.round(value) }}%</strong
                        >
                      </template>
                    </v-progress-linear>
                  </template>

                  <template v-slot:item.vacancy_count="{ item }">
                    <v-chip
                      :color="item.vacancy_count > 0 ? 'error' : 'success'"
                      text-color="white"
                      x-small
                      label
                    >
                      <v-icon x-small left v-if="item.vacancy_count > 0"
                        >mdi-alert</v-icon
                      >
                      {{ item.vacancy_count || 0 }}
                    </v-chip>
                  </template>

                  <template v-slot:item.total_salary="{ item }">
                    <span class="font-weight-bold success--text">{{
                      item.total_salary | currency
                    }}</span>
                  </template>
                  <template v-slot:item.avg_salary="{ item }">
                    <span class="font-weight-bold info--text">{{
                      item.avg_salary | currency
                    }}</span>
                  </template>
                  <template v-slot:item.male_count="{ item }">
                    <v-chip color="info" text-color="white" x-small>{{
                      item.male_count
                    }}</v-chip>
                  </template>
                  <template v-slot:item.female_count="{ item }">
                    <v-chip color="primary" text-color="white" x-small>{{
                      item.female_count
                    }}</v-chip>
                  </template>

                  <template
                    v-for="g in positionGroups"
                    v-slot:[`item.pos_${g.key}`]="{ item }"
                  >
                    <v-chip
                      :key="`chip_${g.key}`"
                      x-small
                      label
                      :color="
                        item[`pos_${g.key}`] > 0
                          ? g.chipColor
                          : 'grey lighten-3'
                      "
                      :text-color="
                        item[`pos_${g.key}`] > 0 ? g.chipTextColor : 'grey'
                      "
                    >
                      {{ item[`pos_${g.key}`] || 0 }}
                    </v-chip>
                  </template>

                  <template v-slot:body.append>
                    <tr class="summary-footer-row">
                      <td class="px-4 py-2">
                        <span
                          class="text-subtitle-2 primary--text font-weight-bold"
                          >รวมทั้งหมด</span
                        >
                      </td>
                      <td class="text-center font-weight-bold">
                        {{ collegeSummaryTotals.total_employees }}
                      </td>
                      <td class="text-center font-weight-bold success--text">
                        {{ collegeSummaryTotals.filled_count }}
                      </td>
                      <td class="text-center">
                        <v-chip
                          color="error"
                          text-color="white"
                          x-small
                          label
                          >{{ collegeSummaryTotals.vacancy_count }}</v-chip
                        >
                      </td>
                      <td></td>
                      <template v-if="collegeSummaryView === 'full'">
                        <td
                          class="text-right font-weight-bold success--text pr-4"
                        >
                          {{ collegeSummaryTotals.total_salary | currency }}
                        </td>
                        <td class="text-right font-weight-bold info--text pr-4">
                          {{ collegeSummaryTotals.avg_salary | currency }}
                        </td>
                        <td class="text-center font-weight-bold info--text">
                          {{ collegeSummaryTotals.male_count }}
                        </td>
                        <td class="text-center font-weight-bold primary--text">
                          {{ collegeSummaryTotals.female_count }}
                        </td>
                      </template>
                      <td
                        v-for="g in positionGroups"
                        :key="`total_${g.key}`"
                        class="text-center font-weight-bold"
                        :style="`color: ${g.totalColor}`"
                      >
                        {{ collegeSummaryTotals[`pos_${g.key}`] || 0 }}
                      </td>
                    </tr>
                  </template>

                  <template v-slot:no-data>
                    <div class="text-center py-8">
                      <v-icon large color="grey lighten-1" class="mb-2"
                        >mdi-folder-open</v-icon
                      >
                      <div class="grey--text">ไม่มีข้อมูล</div>
                    </div>
                  </template>
                </v-data-table>
              </v-card>
            </v-container>
          </v-tab-item>

          <!-- ===== TAB 3: รายชื่อบุคลากร ===== -->
          <v-tab-item>
            <v-container fluid class="pa-4">
              <v-card class="rounded-lg" flat>
                <v-card-title class="flex-wrap">
                  <v-icon left color="primary">mdi-table</v-icon>
                  รายชื่ออัตรากำลังพนักงานราชการ
                  <v-spacer></v-spacer>
                  <div class="d-flex align-center flex-wrap" style="gap:8px;">
                    <v-btn-toggle v-model="idcardFilter" dense color="primary">
                      <v-btn small value="all">ทั้งหมด</v-btn>
                      <v-btn small value="with_id" color="success"
                        >มีบัตร</v-btn
                      >
                      <v-btn small value="without_id" color="warning"
                        >ไม่มีบัตร</v-btn
                      >
                    </v-btn-toggle>
                    <v-btn color="success" small @click="$refs.frame.openAdd()">
                      <v-icon small left>mdi-briefcase-plus</v-icon>เพิ่มกรอบอัตรา
                    </v-btn>
                    <v-btn color="blue-grey" small outlined @click="$refs.frame.openLog()">
                      <v-icon small left>mdi-history</v-icon>ประวัติจัดการกรอบ
                    </v-btn>
                  </div>
                </v-card-title>

                <v-data-table
                  :headers="headers"
                  :items="filteredEmployees"
                  :loading="loading"
                  class="elevation-0"
                  :items-per-page="15"
                  :footer-props="{
                    itemsPerPageOptions: [10, 15, 20, 50, -1],
                    itemsPerPageText: 'แสดง'
                  }"
                  :search="search"
                >
                  <template v-slot:item.id_card="{ item }">
                    <template
                      v-if="
                        item.id_card &&
                          item.id_card !== '0' &&
                          item.id_card !== 0
                      "
                    >
                      <v-chip
                        small
                        color="info lighten-5"
                        text-color="info darken-3"
                        label
                        class="font-weight-medium id-card-chip"
                      >
                        <v-icon x-small left color="info darken-2"
                          >mdi-card-account-details</v-icon
                        >
                        {{ formatIdCard(item.id_card) }}
                      </v-chip>
                    </template>
                    <template v-else>
                      <v-chip
                        small
                        color="error lighten-5"
                        text-color="error darken-2"
                        label
                      >
                        <v-icon x-small left color="error darken-2"
                          >mdi-card-off</v-icon
                        >ไม่มีข้อมูล
                      </v-chip>
                    </template>
                  </template>

                  <template v-slot:item.fname="{ item }">
                    <div class="font-weight-bold">{{ item.fname }}</div>
                    <div class="text-caption grey--text">
                      {{ item.name_postion }}
                    </div>
                  </template>

                  <template v-slot:item.salary_s="{ item }">
                    <span class="font-weight-bold success--text">{{
                      item.salary_s | currency
                    }}</span>
                  </template>

                  <template v-slot:item.sex="{ item }">
                    <v-chip
                      x-small
                      :color="item.sex === 'ชาย' ? 'info' : 'primary'"
                      text-color="white"
                      label
                    >
                      <v-icon x-small left>{{
                        item.sex === "ชาย"
                          ? "mdi-human-male"
                          : "mdi-human-female"
                      }}</v-icon>
                      {{ item.sex }}
                    </v-chip>
                  </template>

                  <template v-slot:item.vacancy_status="{ item }">
                    <v-chip
                      x-small
                      :color="isVacant(item) ? 'error' : 'success'"
                      text-color="white"
                      label
                    >
                      <v-icon x-small left>{{
                        isVacant(item) ? "mdi-account-off" : "mdi-account-check"
                      }}</v-icon>
                      {{ isVacant(item) ? "ว่าง" : "ครองตำแหน่ง" }}
                    </v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      v-if="String(item.id_card || '0') !== '0'"
                      icon
                      small
                      color="indigo"
                      title="ย้าย (ส่วนกลาง) — ลงตำแหน่งว่างของหน่วยงานอื่น"
                      @click="$refs.frame.openMove(item)"
                    >
                      <v-icon small>mdi-account-arrow-right</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      small
                      color="deep-orange"
                      title="ตัดโอนตำแหน่ง (ส่วนกลาง)"
                      @click="$refs.frame.openCut(item)"
                    >
                      <v-icon small>mdi-swap-horizontal-bold</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      small
                      color="primary"
                      @click="government_employeeEdit(item.id_no)"
                      title="แก้ไข"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      small
                      color="error"
                      @click="government_employeeDelete(item.id_no)"
                      title="ลบ"
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:no-data>
                    <div class="text-center py-8">
                      <v-icon large color="grey lighten-1" class="mb-2"
                        >mdi-folder-open</v-icon
                      >
                      <div class="grey--text">ไม่มีข้อมูลในขณะนี้</div>
                    </div>
                  </template>
                </v-data-table>
              </v-card>
            </v-container>
          </v-tab-item>

          <!-- ===== TAB 4: อัตราว่าง ===== -->
          <v-tab-item>
            <v-container fluid class="pa-4">
              <v-alert type="warning" text border="left" dense class="mb-4">
                <v-icon left>mdi-information</v-icon>
                อัตราว่าง คือ ตำแหน่งที่ไม่มีผู้ครองตำแหน่ง
                (ไม่มีชื่อหรือเลขบัตรประชาชน)
              </v-alert>
              <v-row class="mb-4">
                <v-col cols="6" md="3">
                  <v-card outlined class="rounded-lg pa-4 text-center">
                    <div class="text-h3 font-weight-bold error--text">
                      {{ summaryStats.vacancy_count }}
                    </div>
                    <div class="text-caption grey--text">อัตราว่างทั้งหมด</div>
                  </v-card>
                </v-col>
                <v-col cols="6" md="3">
                  <v-card outlined class="rounded-lg pa-4 text-center">
                    <div class="text-h3 font-weight-bold warning--text">
                      {{ summaryStats.vacancy_college_count }}
                    </div>
                    <div class="text-caption grey--text">
                      สถานศึกษาที่มีอัตราว่าง
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="6" md="3">
                  <v-card outlined class="rounded-lg pa-4 text-center">
                    <v-progress-circular
                      :rotate="-90"
                      :size="80"
                      :width="10"
                      :value="100 - vacancyPercentage"
                      :color="getPercentageColor(100 - vacancyPercentage)"
                    >
                      <span class="text-h6 font-weight-bold"
                        >{{ 100 - vacancyPercentage }}%</span
                      >
                    </v-progress-circular>
                    <div class="text-caption grey--text mt-2">
                      อัตราการครองตำแหน่ง
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="6" md="3">
                  <v-card outlined class="rounded-lg pa-4 text-center">
                    <div class="text-h3 font-weight-bold success--text">
                      {{ summaryStats.filled_count }}
                    </div>
                    <div class="text-caption grey--text">ครองตำแหน่งแล้ว</div>
                  </v-card>
                </v-col>
              </v-row>
              <v-card class="rounded-lg" flat>
                <v-card-title>
                  <v-icon left color="error">mdi-account-alert</v-icon
                  >รายชื่อตำแหน่งว่าง
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchVacancy"
                    append-icon="mdi-magnify"
                    label="ค้นหา"
                    outlined
                    dense
                    rounded
                    hide-details
                    style="max-width:300px;"
                  ></v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="vacancyHeaders"
                  :items="vacancyEmployees"
                  :search="searchVacancy"
                  :items-per-page="15"
                  :footer-props="{
                    itemsPerPageOptions: [10, 15, 20, 50, -1],
                    itemsPerPageText: 'แสดง'
                  }"
                  class="elevation-0"
                >
                  <template v-slot:item.organization_name="{ item }">
                    <div class="font-weight-bold">
                      {{ item.organization_name }}
                    </div>
                    <div class="text-caption grey--text">
                      {{ item.province_name }}
                    </div>
                  </template>
                  <template v-slot:item.name_postion="{ item }">
                    <v-chip
                      x-small
                      color="primary lighten-4"
                      text-color="primary darken-3"
                      label
                    >
                      {{ item.name_postion || "ไม่ระบุตำแหน่ง" }}
                    </v-chip>
                  </template>
                  <template v-slot:item.salary_s="{ item }">
                    <span class="font-weight-bold">{{
                      item.salary_s | currency
                    }}</span>
                  </template>
                </v-data-table>
              </v-card>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-card>

      <!-- ===== Add Dialog ===== -->
      <v-dialog
        v-model="addgovernment_employeedialog"
        max-width="900px"
        persistent
        scrollable
      >
        <v-card class="rounded-lg">
          <v-card-title class="success white--text">
            <v-icon class="mr-2" color="white">mdi-plus</v-icon>
            เพิ่มข้อมูลพนักงานราชการใหม่
            <v-spacer></v-spacer>
            <v-btn
              icon
              small
              color="white"
              @click="addgovernment_employeedialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pa-4">
            <v-form ref="addgovernment_employeeform" lazy-validation>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="addgovernment_employee.id_position"
                    label="เลขที่ตำแหน่ง*"
                    required
                    :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="addgovernment_employee.college_code"
                    :items="colleges"
                    item-text="user_name"
                    item-value="user_code"
                    label="วิทยาลัย*"
                    required
                    :rules="[v => !!v || 'กรุณาเลือกวิทยาลัย']"
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="addgovernment_employee.id_card"
                    label="เลขบัตรประชาชน"
                    type="number"
                    outlined
                    dense
                    counter="13"
                    hint="เลขบัตรประชาชน 13 หลัก"
                    :rules="[
                      v =>
                        !v ||
                        String(v).replace(/\D/g, '').length === 13 ||
                        'เลขบัตรต้องมี 13 หลัก'
                    ]"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="addgovernment_employee.title_s"
                    :items="titles"
                    label="คำนำหน้า"
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="addgovernment_employee.frist_name"
                    label="ชื่อ"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="5">
                  <v-text-field
                    v-model="addgovernment_employee.last_name"
                    label="นามสกุล"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="addgovernment_employee.sex"
                    :items="['ชาย', 'หญิง']"
                    label="เพศ"
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="addgovernment_employee.salary_s"
                    label="เงินเดือน"
                    type="number"
                    outlined
                    dense
                    prefix="฿"
                  ></v-text-field>
                </v-col>
                <!-- ── กลุ่มตำแหน่ง + ชื่อตำแหน่ง (ดึงจาก API) ── -->
                <v-col cols="12" md="3">
                  <v-select
                    v-model="addPositionGroup"
                    :items="positionGroupOptions"
                    label="กลุ่มตำแหน่ง"
                    outlined
                    dense
                    clearable
                    :loading="loadingPositions"
                    hint="กรองรายชื่อตำแหน่ง"
                    persistent-hint
                    @change="addgovernment_employee.name_postion = null"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="addgovernment_employee.name_postion"
                    :items="filteredPositionNamesFor('add')"
                    label="ชื่อตำแหน่ง"
                    outlined
                    dense
                    clearable
                    :loading="loadingPositions"
                    no-data-text="ไม่พบชื่อตำแหน่ง"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="addgovernment_employee.type_position"
                    label="ประเภทตำแหน่ง"
                    :items="positionTypes"
                    outlined
                    dense
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn text @click="addgovernment_employeedialog = false">
              <v-icon class="mr-1">mdi-close</v-icon>ยกเลิก
            </v-btn>
            <v-btn color="success" @click="addgovernment_employeeSubmit">
              <v-icon class="mr-1">mdi-check</v-icon>บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ===== Edit Dialog ===== -->
      <v-dialog
        v-model="editgovernment_employeedialog"
        max-width="900px"
        persistent
        scrollable
      >
        <v-card class="rounded-lg">
          <v-card-title class="primary white--text">
            <v-icon class="mr-2" color="white">mdi-pencil</v-icon>
            แก้ไขข้อมูลพนักงานราชการ
            <v-spacer></v-spacer>
            <v-btn
              icon
              small
              color="white"
              @click="editgovernment_employeedialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pa-4">
            <v-alert type="info" text dense border="left" class="mb-3">
              <v-icon small left>mdi-information</v-icon>
              {{ fullname }}
            </v-alert>

            <!-- ── แจ้งเตือนข้อผิดพลาดที่ตรวจพบอัตโนมัติ ── -->
            <v-alert
              v-if="editDataErrors.length > 0"
              type="warning"
              text
              dense
              border="left"
              class="mb-3"
              icon="mdi-alert"
            >
              <div class="font-weight-bold mb-1">
                ตรวจพบข้อมูลที่ควรตรวจสอบ ({{ editDataErrors.length }} รายการ):
              </div>
              <ul class="pl-4 mb-0">
                <li
                  v-for="(err, i) in editDataErrors"
                  :key="i"
                  class="text-body-2"
                >
                  {{ err }}
                </li>
              </ul>
            </v-alert>

            <v-form ref="editgovernment_employeeform" lazy-validation>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="editgovernment_employee.id_position"
                    label="เลขที่ตำแหน่ง"
                    disabled
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="editgovernment_employee.college_code"
                    :items="colleges"
                    item-text="user_name"
                    item-value="user_code"
                    label="วิทยาลัย"
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="editgovernment_employee.id_card"
                    label="เลขบัตรประชาชน"
                    type="number"
                    outlined
                    dense
                    counter="13"
                    hint="เลขบัตรประชาชน 13 หลัก"
                    :error-messages="idCardEditError"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="editgovernment_employee.title_s"
                    :items="titles"
                    label="คำนำหน้า"
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="editgovernment_employee.frist_name"
                    label="ชื่อ"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="5">
                  <v-text-field
                    v-model="editgovernment_employee.last_name"
                    label="นามสกุล"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="editgovernment_employee.sex"
                    :items="['ชาย', 'หญิง']"
                    label="เพศ"
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="editgovernment_employee.salary_s"
                    label="เงินเดือน"
                    type="number"
                    outlined
                    dense
                    prefix="฿"
                    :rules="[
                      v => !v || Number(v) > 0 || 'เงินเดือนต้องมากกว่า 0'
                    ]"
                  >
                  </v-text-field>
                </v-col>
                <!-- ── กลุ่มตำแหน่ง + ชื่อตำแหน่ง (ดึงจาก API) ── -->
                <v-col cols="12" md="3">
                  <v-select
                    v-model="editPositionGroup"
                    :items="positionGroupOptions"
                    label="กลุ่มตำแหน่ง"
                    outlined
                    dense
                    clearable
                    :loading="loadingPositions"
                    hint="กรองรายชื่อตำแหน่ง"
                    persistent-hint
                    @change="editgovernment_employee.name_postion = null"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="editgovernment_employee.name_postion"
                    :items="filteredPositionNamesFor('edit')"
                    label="ชื่อตำแหน่ง"
                    outlined
                    dense
                    clearable
                    :loading="loadingPositions"
                    no-data-text="ไม่พบชื่อตำแหน่ง"
                    :error-messages="positionNotInListWarning"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="editgovernment_employee.type_position"
                    label="ประเภทตำแหน่ง"
                    :items="positionTypes"
                    outlined
                    dense
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pa-4" style="background:#f5f5f5;">
            <v-spacer></v-spacer>
            <v-btn text @click="editgovernment_employeedialog = false">
              <v-icon class="mr-1">mdi-close</v-icon>ยกเลิก
            </v-btn>
            <v-btn color="warning" text @click="clearIdcard" class="mr-2">
              <v-icon class="mr-1">mdi-card-off</v-icon>ลบเลขบัตร
            </v-btn>
            <v-btn color="primary" @click="editgovernment_employeeSubmit">
              <v-icon class="mr-1">mdi-check</v-icon>บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ===== Delete Dialog ===== -->
      <v-dialog
        v-model="deletegovernment_employeedialog"
        max-width="600px"
        persistent
      >
        <v-card class="rounded-lg">
          <v-card-title class="error white--text">
            <v-icon class="mr-2" color="white">mdi-alert</v-icon
            >ยืนยันการลบข้อมูล
          </v-card-title>
          <v-card-text class="py-4">
            <v-alert type="warning" text border="left" dense>
              <div>
                คุณต้องการลบข้อมูลของ
                <strong
                  >{{ editgovernment_employee.title_s
                  }}{{ editgovernment_employee.frist_name }}
                  {{ editgovernment_employee.last_name }}</strong
                >
                หรือไม่?
              </div>
              <div class="text-caption mt-2">
                เลขที่ตำแหน่ง: {{ editgovernment_employee.id_position }}
              </div>
            </v-alert>
            <v-form
              ref="deletegovernment_employeeform"
              lazy-validation
              class="mt-4"
            >
              <v-text-field
                v-model="deleteConfirm"
                label="กรุณาพิมพ์ 'ยืนยันการลบ' เพื่อยืนยัน"
                :rules="[v => v === 'ยืนยันการลบ' || 'ข้อมูลไม่ตรงกัน']"
                outlined
                placeholder="ยืนยันการลบ"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="deletegovernment_employeedialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn color="error" @click="deletegovernment_employeeSubmit">
              <v-icon class="mr-1">mdi-delete</v-icon>ลบข้อมูล
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Loading Overlay -->
      <v-overlay v-model="loading" opacity="0.5">
        <v-progress-circular
          indeterminate
          size="50"
          color="primary"
        ></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import Manpowermenubar_govem from "../../../components/admin/manpowermenubar_govem.vue";
import GovemFrameActions from "../../../components/govem/GovemFrameActions.vue";
import GovemDataQuality from "../../../components/govem/GovemDataQuality.vue";
import UnitAuditLog from "../../../components/govem/UnitAuditLog.vue";
import GovemBudgetRequest from "../../../components/govem/GovemBudgetRequest.vue";
import * as XLSX from "xlsx";

// ── Fallback 28 ตำแหน่ง (ใช้ถ้า name_position.php ไม่พร้อม) ──────────────────
const FALLBACK_POSITIONS = [
  {
    position_code: "NP001",
    position_name: "เจ้าหน้าที่การเงินและบัญชี",
    position_group: "เจ้าหน้าที่"
  },
  {
    position_code: "NP002",
    position_name: "เจ้าหน้าที่กิจการนักศึกษา",
    position_group: "เจ้าหน้าที่"
  },
  {
    position_code: "NP003",
    position_name: "เจ้าหน้าที่งานการค้า",
    position_group: "เจ้าหน้าที่"
  },
  {
    position_code: "NP004",
    position_name: "เจ้าหน้าที่งานทวิภาคี",
    position_group: "เจ้าหน้าที่"
  },
  {
    position_code: "NP005",
    position_name: "เจ้าหน้าที่งานทะเบียน",
    position_group: "เจ้าหน้าที่"
  },
  {
    position_code: "NP006",
    position_name: "เจ้าหน้าที่งานสารบรรณ",
    position_group: "เจ้าหน้าที่"
  },
  {
    position_code: "NP007",
    position_name: "เจ้าหน้าที่ธุรการ",
    position_group: "เจ้าหน้าที่"
  },
  {
    position_code: "NP008",
    position_name: "เจ้าหน้าที่พัสดุ",
    position_group: "เจ้าหน้าที่"
  },
  {
    position_code: "NP009",
    position_name: "พนักงานบริการ (ครู)",
    position_group: "บริการ"
  },
  {
    position_code: "NP010",
    position_name: "พนักงานบริการ (ด้านการเกษตร)",
    position_group: "บริการ"
  },
  {
    position_code: "NP011",
    position_name: "พนักงานบริการ (ด้านการเงินและบัญชี)",
    position_group: "บริการ"
  },
  {
    position_code: "NP012",
    position_name: "พนักงานบริการ (ด้านธุรการ)",
    position_group: "บริการ"
  },
  {
    position_code: "NP013",
    position_name: "พนักงานบริการ (ด้านบริการ)",
    position_group: "บริการ"
  },
  {
    position_code: "NP014",
    position_name: "พนักงานบริการ (ด้านบริหารงานทั่วไป)",
    position_group: "บริการ"
  },
  {
    position_code: "NP015",
    position_name: "พนักงานบริการ (ด้านพัสดุ)",
    position_group: "บริการ"
  },
  {
    position_code: "NP016",
    position_name: "พนักงานบริการ (ด้านโยธา)",
    position_group: "บริการ"
  },
  {
    position_code: "NP017",
    position_name: "พนักงานบริการ (ด้านสารสนเทศ)",
    position_group: "บริการ"
  },
  {
    position_code: "NP018",
    position_name: "พนักงานบริหารทั่วไป (ครู)",
    position_group: "บริหารทั่วไป"
  },
  {
    position_code: "NP019",
    position_name: "พนักงานบริหารทั่วไป (ด้านกฎหมาย)",
    position_group: "บริหารทั่วไป"
  },
  {
    position_code: "NP020",
    position_name: "พนักงานบริหารทั่วไป (ด้านการเงินและบัญชี)",
    position_group: "บริหารทั่วไป"
  },
  {
    position_code: "NP021",
    position_name: "พนักงานบริหารทั่วไป (ด้านบรรณารักษ์)",
    position_group: "บริหารทั่วไป"
  },
  {
    position_code: "NP022",
    position_name: "พนักงานบริหารทั่วไป (ด้านบริหารงานทั่วไป)",
    position_group: "บริหารทั่วไป"
  },
  {
    position_code: "NP023",
    position_name: "พนักงานบริหารทั่วไป (ด้านบริหารงานบุคคล)",
    position_group: "บริหารทั่วไป"
  },
  {
    position_code: "NP024",
    position_name: "พนักงานบริหารทั่วไป (ด้านพัสดุ)",
    position_group: "บริหารทั่วไป"
  },
  {
    position_code: "NP025",
    position_name: "พนักงานบริหารทั่วไป (ด้านเลขานุการ)",
    position_group: "บริหารทั่วไป"
  },
  {
    position_code: "NP026",
    position_name: "พนักงานบริหารทั่วไป (ด้านวิเคราะห์นโยบายและแผน)",
    position_group: "บริหารทั่วไป"
  },
  {
    position_code: "NP027",
    position_name: "พนักงานบริหารทั่วไป (ด้านวิชาการศึกษา)",
    position_group: "บริหารทั่วไป"
  },
  {
    position_code: "NP028",
    position_name: "พนักงานบริหารทั่วไป (ด้านสารสนเทศ)",
    position_group: "บริหารทั่วไป"
  }
];

export default {
  components: { Manpowermenubar_govem, GovemFrameActions, GovemDataQuality, UnitAuditLog, GovemBudgetRequest },

  data() {
    return {
      loading: true,
      isExporting: false,
      isExportingXLSX: false,
      ApiKey: "HRvec2021",
      government_employees: [],
      colleges: [],
      provinces: [],
      regions: [],
      search: "",
      search_college: "",
      college_search: "",
      province_search: "",
      vacancy_filter: "",
      searchVacancy: "",
      activeTab: 0,
      idcardFilter: "all",
      showAllVacancies: false,
      collegeSummaryView: "full",

      addgovernment_employeedialog: false,
      editgovernment_employeedialog: false,
      deletegovernment_employeedialog: false,
      addgovernment_employee: {},
      editgovernment_employee: {},
      delIppostion: {},
      fullname: "",
      deleteConfirm: "",
      data_syslog: {},
      date_today_log: new Date().toISOString().split("T")[0],

      // ── ชื่อตำแหน่ง: โหลดจาก name_position.php ──────────────────────────────
      allPositions: [], // raw list: [{position_code, position_name, position_group, is_active}]
      loadingPositions: false,
      addPositionGroup: null, // filter กลุ่มใน Add dialog
      editPositionGroup: null, // filter กลุ่มใน Edit dialog

      vacancyFilterOptions: [
        { text: "ทั้งหมด", value: "" },
        { text: "ครองตำแหน่ง", value: "filled" },
        { text: "อัตราว่าง", value: "vacant" },
        { text: "ไม่มีเลขบัตรประชาชน", value: "no_idcard" }
      ],

      summaryStats: {
        total_employees: 0,
        total_salary: 0,
        avg_salary: 0,
        min_salary: 0,
        max_salary: 0,
        male_count: 0,
        female_count: 0,
        no_idcard_count: 0,
        with_idcard_count: 0,
        vacancy_count: 0,
        filled_count: 0,
        vacancy_college_count: 0
      },
      collegeSummary: [],
      vacancyCollegeSummary: [],

      titles: [
        "นาย",
        "นาง",
        "นางสาว",
        "ว่าที่ร้อยตรี",
        "ว่าที่ร้อยโท",
        "ว่าที่ร้อยเอก",
        "ดร.",
        "ผศ.",
        "รศ.",
        "ศ."
      ],
      positionTypes: [
        "ตำแหน่งในภารกิจหลัก",
        "ตำแหน่งในภารกิจสนับสนุน",
        "ตำแหน่งในภารกิจสนับสนุนงานวิชาการ"
      ],

      positionGroups: [
        {
          key: "teacher",
          label: "พนง.บริหารทั่วไป (ครู)",
          icon: "mdi-human-male-board",
          chipColor: "blue lighten-4",
          chipTextColor: "blue darken-3",
          totalColor: "#455A64",
          match: n => !!n && n.trim() === "พนักงานบริหารทั่วไป (ครู)"
        },
        {
          key: "admin_general",
          label: "พนง.บริหารทั่วไป (ด้านต่างๆ)",
          icon: "mdi-briefcase-account",
          chipColor: "primary",
          chipTextColor: "primary",
          totalColor: "#b3151b",
          match: n =>
            !!n &&
            n.trim().startsWith("พนักงานบริหารทั่วไป") &&
            n.trim() !== "พนักงานบริหารทั่วไป (ครู)"
        },
        {
          key: "service",
          label: "พนง.บริการ",
          icon: "mdi-room-service",
          chipColor: "teal lighten-4",
          chipTextColor: "teal darken-3",
          totalColor: "#263238",
          match: n => !!n && n.trim().startsWith("พนักงานบริการ")
        },
        {
          key: "officer",
          label: "เจ้าหน้าที่",
          icon: "mdi-badge-account",
          chipColor: "orange lighten-4",
          chipTextColor: "orange darken-3",
          totalColor: "#A86400",
          match: n => !!n && n.trim().startsWith("เจ้าหน้าที่")
        },
        {
          key: "support",
          label: "พนง.สนับสนุนการศึกษา",
          icon: "mdi-school-outline",
          chipColor: "primary",
          chipTextColor: "primary",
          totalColor: "#B3151B",
          match: n => !!n && n.trim().startsWith("พนักงานสนับสนุน")
        },
        {
          key: "other",
          label: "อื่นๆ / ไม่ระบุ",
          icon: "mdi-dots-horizontal-circle",
          chipColor: "grey lighten-2",
          chipTextColor: "grey darken-2",
          totalColor: "#546E7A",
          match: () => true
        }
      ],

      headers: [
        { text: "เลขที่ตำแหน่ง", value: "id_position", width: "110px" },
        { text: "เลขบัตรประชาชน", value: "id_card", width: "180px" },
        { text: "ชื่อ - สกุล", value: "fname", width: "200px" },
        { text: "วิทยาลัย", value: "organization_name", width: "180px" },
        { text: "เพศ", value: "sex", width: "90px" },
        {
          text: "เงินเดือน",
          value: "salary_s",
          width: "110px",
          align: "right"
        },
        { text: "สถานะ", value: "vacancy_status", width: "120px" },
        { text: "การศึกษา", value: "ed_name", width: "140px" },
        { text: "จังหวัด", value: "province_name", width: "100px" },
        {
          text: "จัดการ",
          value: "actions",
          width: "170px",
          sortable: false,
          align: "center"
        }
      ],

      vacancyHeaders: [
        { text: "เลขที่ตำแหน่ง", value: "id_position", width: "120px" },
        { text: "ตำแหน่ง", value: "name_postion", width: "200px" },
        { text: "สถานศึกษา", value: "organization_name" },
        {
          text: "เงินเดือน",
          value: "salary_s",
          width: "120px",
          align: "right"
        },
        { text: "จังหวัด", value: "province_name", width: "120px" }
      ],

      // ── Charts (เหมือนเดิมทุกอย่าง) ──
      genderChartOptions: {
        chart: { type: "donut", animations: { enabled: true, speed: 800 } },
        labels: ["ชาย", "หญิง"],
        colors: ["#B3151B", "#424242"],
        legend: { position: "bottom", fontSize: "13px" },
        dataLabels: {
          enabled: true,
          formatter: val => Math.round(val) + "%",
          style: { fontSize: "12px", fontWeight: "bold" }
        },
        plotOptions: { pie: { donut: { size: "65%" } } }
      },
      genderChartSeries: [],
      vacancyChartOptions: {
        chart: { type: "donut", animations: { enabled: true, speed: 800 } },
        labels: ["ครองตำแหน่ง", "อัตราว่าง"],
        colors: ["#B3151B", "#424242"],
        legend: { position: "bottom", fontSize: "13px" },
        dataLabels: {
          enabled: true,
          formatter: val => Math.round(val) + "%",
          style: { fontSize: "12px", fontWeight: "bold" }
        },
        plotOptions: { pie: { donut: { size: "65%" } } }
      },
      vacancyChartSeries: [],
      idcardChartOptions: {
        chart: { type: "donut", animations: { enabled: true, speed: 800 } },
        labels: ["มีเลขบัตร", "ไม่มีเลขบัตร"],
        colors: ["#B3151B", "#424242"],
        legend: { position: "bottom", fontSize: "13px" },
        dataLabels: {
          enabled: true,
          formatter: val => Math.round(val) + "%",
          style: { fontSize: "12px", fontWeight: "bold" }
        },
        plotOptions: { pie: { donut: { size: "65%" } } }
      },
      idcardChartSeries: [],
      salaryRangeChartOptions: {
        chart: {
          type: "bar",
          toolbar: { show: true },
          animations: { enabled: true, speed: 800 }
        },
        colors: ["#B3151B"],
        xaxis: { categories: [], labels: { style: { fontSize: "11px" } } },
        dataLabels: { enabled: false },
        yaxis: { title: { text: "จำนวนคน" } },
        grid: { borderColor: "#e0e0e0" }
      },
      salaryRangeChartSeries: [],
      positionChartOptions: {
        chart: {
          type: "bar",
          toolbar: { show: true },
          animations: { enabled: true, speed: 800 }
        },
        colors: ["#B3151B"],
        xaxis: { categories: [], labels: { style: { fontSize: "11px" } } },
        dataLabels: { enabled: false },
        yaxis: { title: { text: "จำนวนคน" } },
        grid: { borderColor: "#e0e0e0" }
      },
      positionChartSeries: [],
      educationChartOptions: {
        chart: {
          type: "bar",
          toolbar: { show: true },
          animations: { enabled: true, speed: 800 }
        },
        colors: ["#B3151B"],
        xaxis: { labels: { style: { fontSize: "11px" } } },
        plotOptions: { bar: { horizontal: true, borderRadius: 4 } },
        dataLabels: { enabled: true, style: { fontSize: "11px" } },
        yaxis: { title: { text: "จำนวนคน" } },
        grid: { borderColor: "#e0e0e0" }
      },
      educationChartSeries: [],
      educationChartKey: 0,
      positionTypeChartOptions: {
        chart: { type: "pie", animations: { enabled: true, speed: 800 } },
        labels: [],
        colors: ["#B3151B", "#424242", "#E57373", "#9E9E9E", "#8E1014"],
        legend: { position: "bottom", fontSize: "13px" },
        dataLabels: { enabled: true, formatter: val => Math.round(val) + "%" }
      },
      positionTypeChartSeries: []
    };
  },

  // ════════════════════════════════════════
  computed: {
    // ── ชื่อตำแหน่ง: รายการกลุ่มที่ไม่ซ้ำ สำหรับ v-select กลุ่ม ─────────────
    positionGroupOptions() {
      return [
        ...new Set(this.allPositions.map(p => p.position_group).filter(Boolean))
      ].sort();
    },

    // ── ชื่อตำแหน่งทั้งหมด (active เท่านั้น) ──────────────────────────────────
    positionNames() {
      return this.allPositions
        .filter(p => p.is_active == null || p.is_active == 1)
        .map(p => p.position_name);
    },

    // ── แจ้งเตือน: ชื่อตำแหน่งที่กำลังแก้ไขไม่อยู่ในรายการ ──────────────────
    positionNotInListWarning() {
      const name = this.editgovernment_employee.name_postion;
      if (!name || !this.positionNames.length) return [];
      return this.positionNames.includes(name)
        ? []
        : [`"${name}" ไม่อยู่ในรายการตำแหน่งที่กำหนด`];
    },

    // ── แสดง error ที่ field เลขบัตร ──────────────────────────────────────────
    idCardEditError() {
      const v = this.editgovernment_employee.id_card;
      if (!v || v === 0 || v === "0") return [];
      const s = String(v).replace(/\D/g, "");
      return s.length !== 13 ? ["เลขบัตรต้องมี 13 หลัก"] : [];
    },

    // ── ตรวจสอบข้อผิดพลาดข้อมูลใน Edit dialog อัตโนมัติ ─────────────────────
    editDataErrors() {
      const emp = this.editgovernment_employee;
      const errs = [];

      // เลขบัตรประชาชน
      if (emp.id_card && emp.id_card !== 0 && emp.id_card !== "0") {
        const id = String(emp.id_card).replace(/\D/g, "");
        if (id.length !== 13)
          errs.push(`เลขบัตรประชาชน "${emp.id_card}" ไม่ครบ 13 หลัก`);
      }

      // วันเกิด
      const d = parseInt(emp.brith_day),
        m = parseInt(emp.brith_month),
        y = parseInt(emp.brith_year);
      if (emp.brith_day || emp.brith_month || emp.brith_year) {
        if (!emp.brith_day || !emp.brith_month || !emp.brith_year) {
          errs.push("วันเกิดไม่ครบถ้วน (ต้องการ วัน/เดือน/ปี)");
        } else {
          if (isNaN(d) || d < 1 || d > 31)
            errs.push(`วันเกิด: วัน "${emp.brith_day}" ไม่ถูกต้อง`);
          if (isNaN(m) || m < 1 || m > 12)
            errs.push(`วันเกิด: เดือน "${emp.brith_month}" ไม่ถูกต้อง`);
          if (isNaN(y) || y < 2400 || y > 2570) {
            errs.push(`ปีเกิดพ.ศ. "${emp.brith_year}" ผิดปกติ (ควร 2400–2570)`);
          } else if (!isNaN(d) && !isNaN(m)) {
            const maxDay = new Date(y - 543, m, 0).getDate();
            if (d > maxDay)
              errs.push(
                `วันที่ ${d}/${m} เกินจำนวนวันในเดือน (สูงสุด ${maxDay})`
              );
          }
        }
      }

      // วันสัญญา
      if (
        emp.last_contract_start &&
        emp.last_contract_end &&
        emp.last_contract_end < emp.last_contract_start
      )
        errs.push("วันสิ้นสุดสัญญาอยู่ก่อนวันเริ่มต้น");

      // ชื่อตำแหน่ง
      if (
        emp.name_postion &&
        this.positionNames.length > 0 &&
        !this.positionNames.includes(emp.name_postion)
      )
        errs.push(`ชื่อตำแหน่ง "${emp.name_postion}" ไม่อยู่ในรายการที่กำหนด`);

      return errs;
    },

    // ── Computed เดิมทั้งหมด ────────────────────────────────────────────────────
    vacancyPercentage() {
      if (!this.summaryStats.total_employees) return 0;
      return Math.round(
        (this.summaryStats.vacancy_count / this.summaryStats.total_employees) *
          100
      );
    },
    hasActiveFilters() {
      return !!(
        this.college_search ||
        this.province_search ||
        this.vacancy_filter
      );
    },
    displayVacancyColleges() {
      return this.showAllVacancies
        ? this.vacancyCollegeSummary
        : this.vacancyCollegeSummary.slice(0, 8);
    },
    filteredEmployees() {
      let list = this.government_employees;
      if (this.idcardFilter === "with_id")
        list = list.filter(
          e => e.id_card && e.id_card !== "0" && e.id_card !== 0
        );
      else if (this.idcardFilter === "without_id")
        list = list.filter(
          e => !e.id_card || e.id_card === "0" || e.id_card === 0
        );
      return list;
    },
    vacancyEmployees() {
      return this.government_employees.filter(e => this.isVacant(e));
    },
    classifyPosition() {
      return name_postion => {
        for (const g of this.positionGroups) {
          if (g.key === "other") continue;
          if (g.match(name_postion)) return g.key;
        }
        return "other";
      };
    },
    collegeSummaryWithPositions() {
      return this.collegeSummary.map(cs => {
        const emps = this.government_employees.filter(
          e => (e.college_code || e.user_code) === cs.user_code
        );
        const posCounts = {};
        this.positionGroups.forEach(g => {
          posCounts[`pos_${g.key}`] = 0;
        });
        emps.forEach(e => {
          const key = this.classifyPosition(e.name_postion);
          posCounts[`pos_${key}`] = (posCounts[`pos_${key}`] || 0) + 1;
        });
        return { ...cs, ...posCounts };
      });
    },
    collegeSummaryTotals() {
      const rows = this.collegeSummaryWithPositions;
      const t = {
        total_employees: rows.reduce(
          (s, r) => s + (+r.total_employees || 0),
          0
        ),
        filled_count: rows.reduce((s, r) => s + (+r.filled_count || 0), 0),
        vacancy_count: rows.reduce((s, r) => s + (+r.vacancy_count || 0), 0),
        total_salary: rows.reduce((s, r) => s + (+r.total_salary || 0), 0),
        male_count: rows.reduce((s, r) => s + (+r.male_count || 0), 0),
        female_count: rows.reduce((s, r) => s + (+r.female_count || 0), 0)
      };
      t.avg_salary =
        t.filled_count > 0 ? Math.round(t.total_salary / t.filled_count) : 0;
      this.positionGroups.forEach(g => {
        t[`pos_${g.key}`] = rows.reduce(
          (s, r) => s + (+r[`pos_${g.key}`] || 0),
          0
        );
      });
      return t;
    },
    activeCollegeSummaryHeaders() {
      const base = [
        { text: "สถานศึกษา", value: "organization_name", width: "200px" },
        {
          text: "อัตราทั้งหมด",
          value: "total_employees",
          width: "90px",
          align: "center"
        },
        {
          text: "ครองตำแหน่ง",
          value: "filled_count",
          width: "95px",
          align: "center"
        },
        {
          text: "อัตราว่าง",
          value: "vacancy_count",
          width: "90px",
          align: "center"
        },
        { text: "ครอง (%)", value: "filled_rate", width: "120px" }
      ];
      const salaryGender = [
        {
          text: "เงินเดือนรวม",
          value: "total_salary",
          width: "130px",
          align: "right"
        },
        {
          text: "เงินเดือนเฉลี่ย",
          value: "avg_salary",
          width: "130px",
          align: "right"
        },
        { text: "ชาย", value: "male_count", width: "60px", align: "center" },
        { text: "หญิง", value: "female_count", width: "60px", align: "center" }
      ];
      const posHeaders = this.positionGroups.map(g => ({
        text: g.label,
        value: `pos_${g.key}`,
        width: "115px",
        align: "center",
        sortable: true
      }));
      return this.collegeSummaryView === "full"
        ? [...base, ...salaryGender, ...posHeaders]
        : [...base, ...posHeaders];
    }
  },

  // ════════════════════════════════════════
  filters: {
    currency(value) {
      if (!value) return "0.00";
      return new Intl.NumberFormat("th-TH", {
        style: "currency",
        currency: "THB",
        minimumFractionDigits: 2
      }).format(value);
    }
  },

  // ════════════════════════════════════════
  async mounted() {
    await this.loadPositions(); // โหลดชื่อตำแหน่งก่อน
    await this.loadInitialData();
  },

  // ════════════════════════════════════════
  methods: {
    // ══════════════════════════════════════
    //  โหลดชื่อตำแหน่งจาก name_position.php
    // ══════════════════════════════════════
    async loadPositions() {
      this.loadingPositions = true;
      try {
        const result = await this.$http.get("name_position.php?action=list", {
          headers: { "X-Api-Key": this.ApiKey }
        });
        if (
          result.data &&
          !result.data.error &&
          Array.isArray(result.data.data)
        ) {
          this.allPositions = result.data.data;
        } else {
          this.allPositions = FALLBACK_POSITIONS;
        }
      } catch {
        this.allPositions = FALLBACK_POSITIONS;
      } finally {
        this.loadingPositions = false;
      }
    },

    // กรองชื่อตำแหน่งตามกลุ่มที่เลือก (ใช้กับ Add และ Edit dialog)
    filteredPositionNamesFor(mode) {
      const group =
        mode === "add" ? this.addPositionGroup : this.editPositionGroup;
      const active = this.allPositions.filter(
        p => p.is_active == null || p.is_active == 1
      );
      if (group)
        return active
          .filter(p => p.position_group === group)
          .map(p => p.position_name);
      return active.map(p => p.position_name);
    },

    // ════════════════════════════════════════
    //  Helpers (เหมือนเดิม)
    // ════════════════════════════════════════
    isVacant(item) {
      return (
        (!item.frist_name || item.frist_name.trim() === "") &&
        (!item.id_card || item.id_card === "0" || item.id_card === 0)
      );
    },

    formatIdCard(id) {
      if (!id) return "";
      const s = String(id).replace(/\D/g, "");
      if (s.length !== 13) return s;
      return `${s[0]}-${s.substring(1, 5)}-${s.substring(5, 10)}-${s.substring(
        10,
        12
      )}-${s[12]}`;
    },

    formatCurrencyShort(value) {
      const num = parseFloat(value) || 0;
      if (num >= 1000000000) return (num / 1000000000).toFixed(1) + " พันล้าน";
      if (num >= 1000000) return (num / 1000000).toFixed(1) + " ล้าน";
      if (num >= 1000) return (num / 1000).toFixed(0) + " พัน";
      return num.toFixed(0);
    },

    getPercentageColor(val) {
      if (val > 80) return "success";
      if (val > 50) return "warning";
      return "error";
    },

    getCollegeName(code) {
      const c = this.colleges.find(c => c.user_code === code);
      return c ? c.organization_name : code;
    },
    getProvinceName(id) {
      const p = this.provinces.find(p => p.province_ID === id);
      return p ? p.province_name : id;
    },
    getVacancyFilterLabel(val) {
      const o = this.vacancyFilterOptions.find(o => o.value === val);
      return o ? o.text : val;
    },
    filterByCollege(code) {
      this.college_search = code;
      this.onFilterChange();
    },

    resetFilters() {
      this.college_search = "";
      this.province_search = "";
      this.vacancy_filter = "";
      this.search = "";
      this.onFilterChange();
    },

    // ════════════════════════════════════════
    //  Data Loading (เหมือนเดิม)
    // ════════════════════════════════════════
    async loadInitialData() {
      try {
        this.loading = true;
        let result = await this.$http.post("user.php", {
          ApiKey: this.ApiKey,
          show_user: "ok"
        });
        this.colleges = result.data || [];
        result = await this.$http.post("province.php", { ApiKey: this.ApiKey });
        this.provinces = result.data || [];
        result = await this.$http.post("region.php", { ApiKey: this.ApiKey });
        this.regions = result.data || [];
        await this.loadEmployeeData();
        await this.loadStats();
      } catch (error) {
        console.error("Error loading initial data:", error);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถโหลดข้อมูลได้",
          timer: 3000
        });
      } finally {
        this.loading = false;
      }
    },

    async loadEmployeeData() {
      try {
        const payload = { ApiKey: this.ApiKey };
        if (this.college_search) payload.college_code = this.college_search;
        if (this.province_search) payload.province_ID = this.province_search;
        if (this.vacancy_filter === "no_idcard") payload.no_idcard = true;
        else if (this.vacancy_filter === "vacant") payload.vacancy_only = true;
        else if (this.vacancy_filter === "filled") payload.filled_only = true;
        const result = await this.$http.post(
          "government_employee_news.php",
          payload
        );
        this.government_employees = result.data.data || [];
      } catch (error) {
        console.error("Error loading employee data:", error);
      }
    },

    async loadStats() {
      try {
        const payload = { ApiKey: this.ApiKey };
        if (this.college_search) payload.college_code = this.college_search;
        if (this.province_search) payload.province_ID = this.province_search;
        const result = await this.$http.post(
          "government_employee_stats.php",
          payload
        );
        if (result.data.status) {
          this.summaryStats = {
            ...this.summaryStats,
            ...(result.data.summary || {})
          };
          this.calculateVacancyStats();
          this.collegeSummary = result.data.college_summary || [];
          this.enhanceCollegeSummary();
          this.updateCharts(result.data);
        }
      } catch (error) {
        console.error("Error loading stats:", error);
      }
    },

    calculateVacancyStats() {
      const all = this.government_employees;
      const vacants = all.filter(e => this.isVacant(e));
      this.summaryStats.vacancy_count = vacants.length;
      this.summaryStats.filled_count = all.length - vacants.length;
      const vc = {};
      vacants.forEach(e => {
        const code = e.college_code || e.user_code || "unknown";
        if (!vc[code])
          vc[code] = {
            user_code: code,
            organization_name: e.organization_name || e.user_name || "ไม่ทราบ",
            vacancy_count: 0,
            total_count: 0
          };
        vc[code].vacancy_count++;
      });
      Object.values(vc).forEach(v => {
        v.total_count = all.filter(
          e => (e.college_code || e.user_code) === v.user_code
        ).length;
      });
      this.vacancyCollegeSummary = Object.values(vc).sort(
        (a, b) => b.vacancy_count - a.vacancy_count
      );
      this.summaryStats.vacancy_college_count = this.vacancyCollegeSummary.length;
    },

    enhanceCollegeSummary() {
      this.collegeSummary = this.collegeSummary.map(cs => {
        const vi = this.vacancyCollegeSummary.find(
          v => v.user_code === cs.user_code
        );
        const tot = parseInt(cs.total_employees) || 0;
        const vac = vi ? vi.vacancy_count : 0;
        const fil = tot - vac;
        return {
          ...cs,
          vacancy_count: vac,
          filled_count: fil,
          filled_rate: tot > 0 ? Math.round((fil / tot) * 100) : 100
        };
      });
    },

    updateCharts(statsData) {
      const m = parseInt(this.summaryStats.male_count) || 0,
        f = parseInt(this.summaryStats.female_count) || 0;
      if (m > 0 || f > 0) this.genderChartSeries = [m, f];
      const fi = this.summaryStats.filled_count || 0,
        va = this.summaryStats.vacancy_count || 0;
      if (fi > 0 || va > 0) this.vacancyChartSeries = [fi, va];
      const wi = parseInt(this.summaryStats.with_idcard_count) || 0,
        no = parseInt(this.summaryStats.no_idcard_count) || 0;
      if (wi > 0 || no > 0) this.idcardChartSeries = [wi, no];

      const sr = statsData.salary_ranges || [];
      if (sr.length > 0) {
        this.salaryRangeChartOptions = {
          ...this.salaryRangeChartOptions,
          xaxis: {
            ...this.salaryRangeChartOptions.xaxis,
            categories: sr.map(r => r.salary_range)
          }
        };
        this.salaryRangeChartSeries = [
          { name: "จำนวนคน", data: sr.map(r => parseInt(r.count) || 0) }
        ];
      }
      const pos = (statsData.position_distribution || []).slice(0, 10);
      if (pos.length > 0) {
        this.positionChartOptions = {
          ...this.positionChartOptions,
          xaxis: {
            ...this.positionChartOptions.xaxis,
            categories: pos.map(
              p =>
                (p.name_postion || "ไม่ระบุ").substring(0, 25) +
                ((p.name_postion || "").length > 25 ? "..." : "")
            )
          }
        };
        this.positionChartSeries = [
          { name: "จำนวนคน", data: pos.map(p => parseInt(p.count) || 0) }
        ];
      }
      const ed = statsData.education_levels || [];
      if (ed.length > 0) {
        const eg = {};
        ed.forEach(e => {
          let l = (e.level_edd || "ไม่ระบุ").trim();
          const c = parseInt(e.count) || 0;
          if (
            l.startsWith("ปริญญาตรี") ||
            l.startsWith("ปริญา") ||
            l.startsWith("ปริย")
          )
            l = "ปริญญาตรีหรือเทียบเท่า";
          else if (
            l.startsWith("ประกาศนียบัตรวิชาชีพชั้นสูง") ||
            l.includes("ปวส")
          )
            l = "ปวส.";
          else if (l.startsWith("ประกาศนียบัตรวิชาชีพ") || l.includes("ปวช"))
            l = "ปวช.";
          if (l.length > 20) l = l.substring(0, 20) + "...";
          eg[l] = (eg[l] || 0) + c;
        });
        const sorted = Object.entries(eg).sort(([, a], [, b]) => b - a);
        this.educationChartOptions = {
          ...this.educationChartOptions,
          xaxis: {
            ...this.educationChartOptions.xaxis,
            categories: sorted.map(([l]) => l)
          }
        };
        this.educationChartSeries = [
          { name: "จำนวนคน", data: sorted.map(([, c]) => c) }
        ];
        this.educationChartKey++;
      }
      const ptg = {};
      this.government_employees.forEach(e => {
        const t = e.type_position || "ไม่ระบุ";
        ptg[t] = (ptg[t] || 0) + 1;
      });
      const pte = Object.entries(ptg).sort(([, a], [, b]) => b - a);
      if (pte.length > 0) {
        this.positionTypeChartOptions = {
          ...this.positionTypeChartOptions,
          labels: pte.map(([l]) => l)
        };
        this.positionTypeChartSeries = pte.map(([, c]) => c);
      }
    },

    async onFilterChange() {
      this.loading = true;
      try {
        await this.loadEmployeeData();
        await this.loadStats();
      } finally {
        this.loading = false;
      }
    },

    async idPosition_search() {
      if (!this.search) return;
      this.loading = true;
      try {
        const result = await this.$http.post("government_employee_news.php", {
          ApiKey: this.ApiKey,
          id_position: this.search
        });
        this.government_employees = result.data.data || [];
      } finally {
        this.loading = false;
      }
    },

    // ── CRUD (เหมือนเดิม) ────────────────────────────────────────────────────
    government_employeeAdd() {
      this.addgovernment_employee = {};
      this.addPositionGroup = null; // reset filter กลุ่ม
      this.addgovernment_employeedialog = true;
    },

    async addgovernment_employeeSubmit() {
      if (!this.$refs.addgovernment_employeeform.validate()) return;
      this.loading = true;
      try {
        this.addgovernment_employee.ApiKey = this.ApiKey;
        const result = await this.$http.post(
          "government_employee.insert.php",
          this.addgovernment_employee
        );
        if (result.data.status === true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          const userSession = JSON.parse(localStorage.getItem("user")) || {};
          await this.$http.post("data_syslog.insert.php", {
            ApiKey: this.ApiKey,
            user_account: userSession.user_name || "",
            event_log: "insert",
            page_log: "government_employee",
            table_log: "government_employee",
            detail_log: `${this.addgovernment_employee.id_position}:${this.addgovernment_employee.college_code}`,
            date_times: this.date_today_log
          });
          await this.onFilterChange();
          this.addgovernment_employeedialog = false;
        }
      } catch (error) {
        console.error("Error:", error);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: error.message,
          timer: 3000
        });
      } finally {
        this.loading = false;
      }
    },

    async government_employeeEdit(id_no) {
      this.loading = true;
      try {
        const result = await this.$http.post("government_employee_news.php", {
          ApiKey: this.ApiKey,
          id_no
        });
        this.editgovernment_employee = result.data.data || {};
        this.editgovernment_employeeFullname();
        // ── ตั้ง editPositionGroup อัตโนมัติจากชื่อตำแหน่งที่มีอยู่ ──
        const found = this.allPositions.find(
          p => p.position_name === this.editgovernment_employee.name_postion
        );
        this.editPositionGroup = found ? found.position_group : null;
        this.editgovernment_employeedialog = true;
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.loading = false;
      }
    },

    editgovernment_employeeFullname() {
      this.fullname =
        (this.editgovernment_employee.id_card || "ไม่มีเลขบัตร") +
        " : " +
        (this.editgovernment_employee.title_s || "") +
        (this.editgovernment_employee.frist_name || "") +
        " " +
        (this.editgovernment_employee.last_name || "");
    },

    async editgovernment_employeeSubmit() {
      if (!this.$refs.editgovernment_employeeform.validate()) return;
      this.loading = true;
      try {
        this.editgovernment_employee.ApiKey = this.ApiKey;
        const result = await this.$http.post(
          "government_employee.update.php",
          this.editgovernment_employee
        );
        if (result.data.status === true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการแก้ไขข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          const userSession = JSON.parse(localStorage.getItem("user")) || {};
          await this.$http.post("data_syslog.insert.php", {
            ApiKey: this.ApiKey,
            user_account: userSession.user_name || "",
            event_log: "update",
            page_log: "government_employee",
            table_log: "government_employee",
            detail_log: `${this.editgovernment_employee.id_position} : ${this.editgovernment_employee.college_code}`,
            date_times: this.date_today_log
          });
          await this.onFilterChange();
          this.editgovernment_employeedialog = false;
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.loading = false;
      }
    },

    async clearIdcard() {
      const text = `เลขที่ตำแหน่ง : ${this.editgovernment_employee.id_position} โดย : ${this.editgovernment_employee.id_card}`;
      this.$swal
        .fire({
          title: "ต้องการลบเลขบัตรประชาชนหรือไม่?",
          text,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#b3151b",
          cancelButtonColor: "#d33",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก"
        })
        .then(async result => {
          if (result.isConfirmed) {
            this.loading = true;
            try {
              const payload = {
                ...this.editgovernment_employee,
                ApiKey: this.ApiKey,
                id_card: 0
              };
              const res = await this.$http.post(
                "government_employee.update.php",
                payload
              );
              if (res.data.status === true) {
                Swal.fire({
                  icon: "success",
                  title: "ดำเนินการลบเลขบัตรเรียบร้อย",
                  showConfirmButton: false,
                  timer: 1500
                });
                await this.onFilterChange();
                this.editgovernment_employee.id_card = 0;
              }
            } catch (error) {
              console.error("Error:", error);
            } finally {
              this.loading = false;
            }
          }
        });
    },

    government_employeeDelete(id_no) {
      this.$http
        .post("government_employee_news.php", { ApiKey: this.ApiKey, id_no })
        .then(result => {
          this.editgovernment_employee = result.data.data || {};
          this.deleteConfirm = "";
          this.deletegovernment_employeedialog = true;
        });
    },

    async deletegovernment_employeeSubmit() {
      if (!this.$refs.deletegovernment_employeeform.validate()) return;
      if (this.deleteConfirm !== "ยืนยันการลบ") return;
      this.loading = true;
      try {
        this.editgovernment_employee.ApiKey = this.ApiKey;
        const result = await this.$http.post(
          "government_employee.delete.php",
          this.editgovernment_employee
        );
        if (result.data.status === true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการลบข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          const userSession = JSON.parse(localStorage.getItem("user")) || {};
          await this.$http.post("data_syslog.insert.php", {
            ApiKey: this.ApiKey,
            user_account: userSession.user_name || "",
            event_log: "delete",
            page_log: "government_employee",
            table_log: "government_employee",
            detail_log: `${this.editgovernment_employee.id_position} : ${this.editgovernment_employee.college_code}`,
            date_times: this.date_today_log
          });
          await this.onFilterChange();
          this.deletegovernment_employeedialog = false;
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.loading = false;
      }
    },

    // ── Export XLSX (เหมือนเดิม) ─────────────────────────────────────────────
    async exportCollegeSummaryXLSX() {
      this.isExportingXLSX = true;
      try {
        const wb = XLSX.utils.book_new();
        const date = new Date().toISOString().split("T")[0];
        const posKeys = this.positionGroups.map(g => g.key);

        const h1 = [
          "รหัสสถานศึกษา",
          "สถานศึกษา",
          "อัตรากำลัง",
          "",
          "",
          "",
          "เงินเดือน",
          "",
          "",
          "เพศ",
          "",
          "จำแนกตามประเภทตำแหน่ง",
          ...Array(posKeys.length - 1).fill("")
        ];
        const h2 = [
          "",
          "",
          "ทั้งหมด",
          "ครองตำแหน่ง",
          "อัตราว่าง",
          "ครอง(%)",
          "รวม(บาท)",
          "เฉลี่ย(บาท)",
          "",
          "ชาย",
          "หญิง",
          ...this.positionGroups.map(g => g.label)
        ];
        const dataRows = this.collegeSummaryWithPositions.map(r => [
          r.user_code,
          r.organization_name,
          +r.total_employees || 0,
          +r.filled_count || 0,
          +r.vacancy_count || 0,
          +(r.filled_rate || 0),
          +r.total_salary || 0,
          +r.avg_salary || 0,
          "",
          +r.male_count || 0,
          +r.female_count || 0,
          ...posKeys.map(k => +r[`pos_${k}`] || 0)
        ]);
        const tot = this.collegeSummaryTotals;
        const totalRow = [
          "",
          "รวมทั้งหมด",
          tot.total_employees,
          tot.filled_count,
          tot.vacancy_count,
          tot.total_employees > 0
            ? +((tot.filled_count / tot.total_employees) * 100).toFixed(1)
            : 0,
          tot.total_salary,
          tot.avg_salary,
          "",
          tot.male_count,
          tot.female_count,
          ...posKeys.map(k => tot[`pos_${k}`] || 0)
        ];
        const ws1 = XLSX.utils.aoa_to_sheet([h1, h2, ...dataRows, totalRow]);
        ws1["!cols"] = [
          { wch: 14 },
          { wch: 42 },
          { wch: 10 },
          { wch: 12 },
          { wch: 10 },
          { wch: 9 },
          { wch: 16 },
          { wch: 16 },
          { wch: 4 },
          { wch: 8 },
          { wch: 8 },
          ...posKeys.map(() => ({ wch: 20 }))
        ];
        ws1["!merges"] = [
          { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
          { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } },
          { s: { r: 0, c: 2 }, e: { r: 0, c: 5 } },
          { s: { r: 0, c: 6 }, e: { r: 0, c: 8 } },
          { s: { r: 0, c: 9 }, e: { r: 0, c: 10 } },
          { s: { r: 0, c: 11 }, e: { r: 0, c: 11 + posKeys.length - 1 } }
        ];
        XLSX.utils.book_append_sheet(wb, ws1, "สรุปตามสถานศึกษา");

        const allPos = [
          ...new Set(
            this.government_employees
              .map(e => e.name_postion || "ไม่ระบุ")
              .filter(Boolean)
          )
        ].sort();
        const ph = ["รหัสสถานศึกษา", "สถานศึกษา", "รวมทั้งหมด", ...allPos];
        const pRows = this.collegeSummary.map(cs => {
          const emps = this.government_employees.filter(
            e => (e.college_code || e.user_code) === cs.user_code
          );
          const cnt = {};
          allPos.forEach(p => {
            cnt[p] = 0;
          });
          emps.forEach(e => {
            const p = e.name_postion || "ไม่ระบุ";
            cnt[p] = (cnt[p] || 0) + 1;
          });
          return [
            cs.user_code,
            cs.organization_name,
            emps.length,
            ...allPos.map(p => cnt[p] || 0)
          ];
        });
        const pTotal = [
          "",
          "รวม",
          pRows.reduce((s, r) => s + (+r[2] || 0), 0),
          ...allPos.map((_, i) =>
            pRows.reduce((s, r) => s + (+r[3 + i] || 0), 0)
          )
        ];
        const ws2 = XLSX.utils.aoa_to_sheet([ph, ...pRows, pTotal]);
        ws2["!cols"] = [
          { wch: 14 },
          { wch: 42 },
          { wch: 10 },
          ...allPos.map(() => ({ wch: 30 }))
        ];
        XLSX.utils.book_append_sheet(wb, ws2, "จำแนกตามชื่อตำแหน่ง");

        const vh = [
          "เลขที่ตำแหน่ง",
          "ชื่อตำแหน่ง",
          "ประเภทตำแหน่ง",
          "สถานศึกษา",
          "จังหวัด",
          "เงินเดือน"
        ];
        const vRows = this.vacancyEmployees.map(e => [
          e.id_position,
          e.name_postion || "ไม่ระบุ",
          e.type_position || "ไม่ระบุ",
          e.organization_name || e.user_name || "",
          e.province_name || "",
          +e.salary_s || 0
        ]);
        const ws3 = XLSX.utils.aoa_to_sheet([vh, ...vRows]);
        ws3["!cols"] = [
          { wch: 14 },
          { wch: 35 },
          { wch: 28 },
          { wch: 42 },
          { wch: 18 },
          { wch: 12 }
        ];
        XLSX.utils.book_append_sheet(wb, ws3, "อัตราว่าง");

        XLSX.writeFile(wb, `สรุปอัตรากำลัง_${date}.xlsx`);
      } catch (err) {
        console.error(err);
        if (this.$swal)
          this.$swal.fire({
            icon: "error",
            title: "ส่งออกไม่สำเร็จ",
            text: err.message
          });
      } finally {
        this.isExportingXLSX = false;
      }
    },

    exportToCSV() {
      const csvHeaders = [
        "เลขที่ตำแหน่ง",
        "เลขบัตรประชาชน",
        "ชื่อ-สกุล",
        "ตำแหน่ง",
        "ประเภทตำแหน่ง",
        "วิทยาลัย",
        "เพศ",
        "เงินเดือน",
        "สถานะ",
        "จังหวัด"
      ];
      const data = this.government_employees.map(emp => [
        emp.id_position,
        emp.id_card || "",
        (emp.title_s || "") +
          (emp.frist_name || "") +
          " " +
          (emp.last_name || ""),
        emp.name_postion,
        emp.type_position || "",
        emp.user_name || emp.organization_name || "",
        emp.sex,
        emp.salary_s,
        this.isVacant(emp) ? "อัตราว่าง" : "ครองตำแหน่ง",
        emp.province_name
      ]);
      this._downloadCSV(
        [csvHeaders, ...data],
        `government_employee_${new Date().toISOString().split("T")[0]}.csv`
      );
    },

    exportSummaryToCSV() {
      const csvHeaders = [
        "รหัสสถานศึกษา",
        "สถานศึกษา",
        "จำนวนอัตรา",
        "ครองตำแหน่ง",
        "อัตราว่าง",
        "อัตราครอง(%)",
        "เงินเดือนรวม",
        "เงินเดือนเฉลี่ย",
        "ชาย",
        "หญิง",
        ...this.positionGroups.map(g => g.label)
      ];
      const data = this.collegeSummaryWithPositions.map(r => [
        r.user_code,
        r.organization_name,
        r.total_employees,
        r.filled_count || 0,
        r.vacancy_count || 0,
        r.filled_rate || 0,
        r.total_salary,
        r.avg_salary,
        r.male_count,
        r.female_count,
        ...this.positionGroups.map(g => r[`pos_${g.key}`] || 0)
      ]);
      this._downloadCSV(
        [csvHeaders, ...data],
        `สรุปอัตรากำลังสถานศึกษา_${new Date().toISOString().split("T")[0]}.csv`
      );
    },

    _downloadCSV(rows, filename) {
      const csv = rows
        .map(row => row.map(cell => `"${cell || ""}"`).join(","))
        .join("\n");
      const blob = new Blob(["\uFEFF" + csv], {
        type: "text/csv;charset=utf-8;"
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    }
  }
};
</script>

<style scoped>
.app-bg {
  background: linear-gradient(135deg, #f5f5f5 0%, #f5f5f5 100%);
  min-height: 100vh;
}
.header-card {
  overflow: hidden;
}
.header-title-bar {
  background: var(--hv-hero);
}
.filter-section {
  background: linear-gradient(180deg, #f5f5f5 0%, #f5f5f5 100%);
  border-top: 1px solid #f5f5f5;
}
.filter-input .v-input__slot {
  border-radius: 8px !important;
}
.summary-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;
  position: relative;
}
.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12) !important;
}
.summary-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
}
.summary-card--total::before {
  background: linear-gradient(90deg, #455a64, #455a64);
}
.summary-card--vacancy::before {
  background: linear-gradient(90deg, #d32f2f, #ef5350);
}
.summary-card--salary::before {
  background: linear-gradient(90deg, #2e7d32, #2e7d32);
}
.summary-card--gender::before {
  background: linear-gradient(90deg, #b3151b, #b3151b);
}
.summary-icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.summary-icon--blue {
  background: linear-gradient(135deg, #455a64, #455a64);
}
.summary-icon--red {
  background: linear-gradient(135deg, #d32f2f, #ef5350);
}
.summary-icon--green {
  background: linear-gradient(135deg, #2e7d32, #2e7d32);
}
.summary-icon--purple {
  background: linear-gradient(135deg, #b3151b, #b3151b);
}
.vacancy-header {
  background: linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%);
}
.vacancy-college-card {
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #e0e0e0 !important;
}
.vacancy-college-card:hover {
  background: #fff4dc;
  border-color: #A86400 !important;
  transform: translateY(-1px);
}
.college-position-table >>> th {
  white-space: normal !important;
  word-break: keep-all;
  line-height: 1.35;
  font-size: 12px !important;
  vertical-align: bottom;
  padding-bottom: 8px !important;
}
.summary-footer-row {
  background: #f5f5f5 !important;
}
.summary-footer-row td {
  border-top: 2px solid #455a64 !important;
  font-weight: 700;
}
.id-card-chip {
  font-family: "Courier New", Courier, monospace;
  letter-spacing: 0.5px;
  font-size: 12px !important;
}
.border-bottom {
  border-bottom: 1px solid #e0e0e0;
}
.h-100 {
  height: 100%;
}
</style>
